export default __webpack_public_path__ + "static/media/Bindings of the Eternal Blaze.f82487d3.jpg";